module.exports = __webpack_public_path__ + "static/media/Lato-Regular.211df29c.woff2";